import { render, staticRenderFns } from "./SkeletonCard.vue?vue&type=template&id=c388932c"
import script from "./SkeletonCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonCard.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports